import Lenis from '@studio-freight/lenis'

class Scroller {
  constructor() {
  
    this.documentScroller()

    const modals = document.querySelectorAll('.c-modal')
    modals.forEach((modal) => {
      const wrapper = modal
      const content = modal.querySelector('.c-modal__wrapper')
      const scroller = new Lenis({
        wrapper,
        content,
        duration: 1.2,
          easing: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)), //eslint-disable-line
        direction: 'vertical',
        gestureDirection: 'vertical',
        smooth: true,
        smoothTouch: false,
        touchMultiplier: 2,
      })

      function raf(time) {
        scroller.raf(time)
        requestAnimationFrame(raf.bind(this))
      }

      requestAnimationFrame(raf.bind(this))
    })
  }

  documentScroller() {
    let isHome = window.location.pathname === '/' || window.location.pathname === '/fr/' // Infinite scrolling only on the homepage
    
    window.lenis = new Lenis({
      duration: 1.2,
      easing: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)), //eslint-disable-line
      direction: 'vertical',
      gestureDirection: 'vertical',
      smooth: true,
      smoothTouch: false,
      touchMultiplier: 2,
      infinite: isHome,
    })

    function raf(time) {
      window.lenis.raf(time)
      requestAnimationFrame(raf.bind(this))
    }

    requestAnimationFrame(raf.bind(this))
  }

  reset() {
    window.lenis.destroy()
    this.documentScroller()
  }
}

export default Scroller
